import styled from 'styled-components';
import { th } from 'style/theme';
import { sizes } from 'style';

export const StyledCostCoverage = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media ${sizes.tabletPortrait} {
    flex-direction: row;
    align-items: flex-start;
  }

  > * {
    flex: 1;
  }
`;

export const SWCovers = styled.div`
  padding: 12px;
  border-radius: 10px;
  border: 1px solid ${th('colors.blue')};
  font-size: 14px;
  line-height: 24px;
  background-color: ${th('colors.blue')}33;
`;

export const YouCover = styled.div`
  padding: 12px;
  border-radius: 10px;
  border: 1px solid ${th('colors.orange')};
  font-size: 14px;
  line-height: 24px;
  background-color: ${th('colors.orange')}33;
`;
